//
// EnvironmentPanel
//
// Select your project environment options here. Think language, channel, ordering,
// and fieldlist.

import { observer } from 'mobx-react-lite'
import { useStore } from '../stores'

import { HView } from '../appview'
import { Property, Select } from '../components'

export const EnvironmentPanel = observer(function EnvironmentPanel({
    project,
    environment,
    updateEnvironment,
    showLanguage,
    showLabelView,
    showAll,
}) {
    const { data, app, view } = useStore()

    let languages = new Map()
    project.languages.map(language =>
        languages.set(language, app.text(data.languages.get(language).name))
    )
    let orderedchannels = new Map()
    project.orderedchannels.forEach(key => {
        orderedchannels.set(key, project.channels.get(key))
    })
    let orderedorderings = new Map()
    project.orderedorderings.forEach(key => {
        orderedorderings.set(key, project.orderings.get(key))
    })
    let orderedfieldlists = new Map()
    project.orderedfieldlists.forEach(key => {
        orderedfieldlists.set(key, project.fieldlists.get(key))
    })
    let labelViews = new Map()
    view.labelViews.map(labelView => labelViews.set(labelView, app.text(labelView)))

    return (
        <HView className="panel environment-panel">
            {showLabelView || showAll ? (
                <Property label={app.text('show')}>
                    <Select
                        value={environment.get('labelView')}
                        onChange={value => updateEnvironment({ labelView: value })}
                        options={labelViews}
                    />
                </Property>
            ) : undefined}
            {showLanguage || showAll ? (
                <Property label={app.text('language')}>
                    <Select
                        value={environment.get('language')}
                        onChange={value => updateEnvironment({ language: value })}
                        options={languages}
                    />
                </Property>
            ) : undefined}
            {showAll ? (
                <>
                    <Property label={app.text('channel')}>
                        <Select
                            value={environment.get('channel')}
                            onChange={value => updateEnvironment({ channel: value })}
                            options={orderedchannels}
                        />
                    </Property>
                    <Property label={app.text('ordering')}>
                        <Select
                            value={environment.get('ordering')}
                            onChange={value => updateEnvironment({ ordering: value })}
                            options={orderedorderings}
                        />
                    </Property>
                    <Property label={app.text('fieldlist')}>
                        <Select
                            value={environment.get('fieldlist')}
                            onChange={value => updateEnvironment({ fieldlist: value })}
                            options={orderedfieldlists}
                        />
                    </Property>
                </>
            ) : undefined}
        </HView>
    )
})
